import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import './CricketClubTeaser.css';

const CricketClubTeaser = () => {
    const [logo, setLogo] = useState('');

    useEffect(() => {
        api.get('/content/cricketclub')
            .then(r => setLogo(r.data?.logo || ''))
            .catch(() => {});
    }, []);

    return (
    <section className="cc-teaser section">
        <div className="container">
            <div className="cc-teaser-inner">
                <div className="cc-teaser-image">
                    <img src={logo || '/assets/img/logo.jpg'} alt="MNC West Cricket Club" />
                    <div className="cc-teaser-badge">
                        <i className="fas fa-baseball-ball"></i>
                        <span>New</span>
                    </div>
                </div>

                <div className="cc-teaser-content">
                    <span className="cc-teaser-label">Sports Division</span>
                    <h2>MNC West Cricket Club</h2>
                    <p>
                        MNCW has officially launched its very own cricket club — <strong>MNC West Club</strong>.
                        We welcome cricket players from Melbourne West to join our team and represent
                        the Nepalese community on the field.
                    </p>

                    <div className="cc-teaser-members">
                        <div className="cc-teaser-member-photos">
                            <img src="/assets/img/team/keshab.png" alt="Keshab Pandey" />
                            <img src="/assets/img/team/jyoti.jpg"  alt="Jyoti Karki" />
                        </div>
                        <p className="cc-teaser-member-text">
                            Led by a dedicated founding subcommittee
                        </p>
                    </div>

                    <div className="cc-teaser-actions">
                        <Link to="/cricket-club" className="btn btn-primary">
                            <i className="fas fa-baseball-ball"></i> Learn More
                        </Link>
                        <Link to="/membership#pricing" className="btn btn-outline">
                            <i className="fas fa-user-plus"></i> Join the Club
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};

export default CricketClubTeaser;
